/**
 * W tym pliku zamieszczać funkcje używające htmlu
 * Te funkcje MUSZĄ być oddzielnie od wspólnych funkcji nieużywających htmlu,
 * gdyż biblioteki typescript w trybie html i serviceworker konfliktują ze sobą
 */


export function getRootElement(element: Element) {
    let result = element;
    while(result.parentElement) {
        result = result.parentElement;
    }
    return result;
}
export function onMainComponentLoaded(element: HTMLElement) {
    getRootElement(element).classList.add('nfhotel-loaded');
}
export function onTranslationsReady(element: HTMLElement) {
    getRootElement(element).classList.add('nfhotel-translations-loaded');
}

/**
 * Sprawdza czy element jest aktualnie widoczny na ekranie
 * @param elem
 */
export function isElementVisible(elem: HTMLElement) {
    const visibilityRect = elem.getBoundingClientRect();
    if(visibilityRect.top > window.innerHeight) {
        return false;
    }
    if(visibilityRect.bottom < 0) {
        return false;
    }
    return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
}
